import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { ConstantService } from "../utils/constant.service";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { Timer } from "./timer_entity";

@Injectable()
export class TimerService {
    private url = "login"
    private token: string;
    constructor(private http:Http, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
        this.token = "";
    }

    consultaTimer(token:string):Observable<Date> {
        this.token = token;
        let timer = new Timer();
        timer.Token = this.token;
        let body = JSON.stringify(timer);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(this.url + "/consultarTiempoToken", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/timer/timer.service.ts